import { render, staticRenderFns } from "./FavoriteButton.vue?vue&type=template&id=729624f3&"
import script from "./FavoriteButton.vue?vue&type=script&lang=ts&"
export * from "./FavoriteButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports